export const authenticatedHomePath = (isAcmiClient: boolean, isRefuelEuReader = false) =>
  isRefuelEuReader ? "/fuel/refuel-eu" : isAcmiClient ? "/flights" : "/ops";
